{
  "realTimeTags": [
    "MS.EAF.KWH",
    "MS.EAF.N2.ACTUAL_HEAT_NUMBER_LS",
    "MS.LRF.N2.ACTUAL_HEAT_NUMBER_LS",
    "MS.CASTER1.N2.ACTUAL_HEAT_NUMBER_LS",
    "MS.EAF.PHASE_SEC_VOL1",
    "MS.EAF.PHASE_SEC_VOL2",
    "MS.EAF.PHASE_SEC_VOL3",
    "MS.EAF.PHASE_CURR1",
    "MS.EAF.PHASE_CURR2",
    "MS.EAF.PHASE_CURR3",
    "MS.EAF.TAP",
    "MS.EAF.INCLINOMETER",
    "MS.LRF.PHASE_CURR_A",
    "MS.LRF.PHASE_VOL_A",
    "MS.LRF.PHASE_CURR_B",
    "MS.LRF.PHASE_VOL_B",
    "MS.LRF.PHASE_CURR_C",
    "MS.LRF.PHASE_VOL_C",
    "MS.CASTER1.N2.STR01.RUN_STATUS",
    "MS.CASTER1.N2.STR02.RUN_STATUS",
    "MS.CASTER1.N2.STR03.RUN_STATUS",
    "MS.CASTER1.N2.STR04.RUN_STATUS",
    "MS.CASTER1.N2.STR05.RUN_STATUS",
    "MS.CASTER1.N2.STR01.SWV_CALCULATION",
    "MS.CASTER1.N2.STR02.SWV_CALCULATION",
    "MS.CASTER1.N2.STR03.SWV_CALCULATION",
    "MS.CASTER1.N2.STR04.SWV_CALCULATION",
    "MS.CASTER1.N2.STR05.SWV_CALCULATION",
    "MS.CASTER1.AUTO_SUPER_HEAT",
    "MS.CASTER1.TURRET.A1.GROSS_WEIGHT",
    "MS.CASTER1.TURRET.A2.GROSS_WEIGHT",
    "MS.CASTER1.FEMS.STR01.ACTUAL_CURRENT",
    "MS.CASTER1.FEMS.STR01.ACTUAL_FLOW",
    "MS.CASTER1.FEMS.STR01.ACTUAL_FRECUENCY",
    "MS.CASTER1.FEMS.STR02.ACTUAL_CURRENT",
    "MS.CASTER1.FEMS.STR02.ACTUAL_FLOW",
    "MS.CASTER1.FEMS.STR02.ACTUAL_FRECUENCY",
    "MS.CASTER1.FEMS.STR03.ACTUAL_CURRENT",
    "MS.CASTER1.FEMS.STR03.ACTUAL_FLOW",
    "MS.CASTER1.FEMS.STR03.ACTUAL_FRECUENCY",
    "MS.CASTER1.FEMS.STR04.ACTUAL_CURRENT",
    "MS.CASTER1.FEMS.STR04.ACTUAL_FLOW",
    "MS.CASTER1.FEMS.STR04.ACTUAL_FRECUENCY",
    "MS.CASTER1.FEMS.STR05.ACTUAL_CURRENT",
    "MS.CASTER1.FEMS.STR05.ACTUAL_FLOW",
    "MS.CASTER1.FEMS.STR05.ACTUAL_FRECUENCY",
    "MS.CASTER1.MEMS.STR01.ACTUAL_CURRENT",
    "MS.CASTER1.MEMS.STR01.ACTUAL_FLOW",
    "MS.CASTER1.MEMS.STR01.ACTUAL_FRECUENCY",
    "MS.CASTER1.MEMS.STR02.ACTUAL_CURRENT",
    "MS.CASTER1.MEMS.STR02.ACTUAL_FLOW",
    "MS.CASTER1.MEMS.STR02.ACTUAL_FRECUENCY",
    "MS.CASTER1.MEMS.STR03.ACTUAL_CURRENT",
    "MS.CASTER1.MEMS.STR03.ACTUAL_FLOW",
    "MS.CASTER1.MEMS.STR03.ACTUAL_FRECUENCY",
    "MS.CASTER1.MEMS.STR04.ACTUAL_CURRENT",
    "MS.CASTER1.MEMS.STR04.ACTUAL_FLOW",
    "MS.CASTER1.MEMS.STR04.ACTUAL_FRECUENCY",
    "MS.CASTER1.MEMS.STR05.ACTUAL_CURRENT",
    "MS.CASTER1.MEMS.STR05.ACTUAL_FLOW",
    "MS.CASTER1.MEMS.STR05.ACTUAL_FRECUENCY",
    "MS.CASTER1.MOULD.LEVEL.STR01.ACTUAL",
    "MS.CASTER1.MOULD.LEVEL.STR02.ACTUAL",
    "MS.CASTER1.MOULD.LEVEL.STR03.ACTUAL",
    "MS.CASTER1.MOULD.LEVEL.STR04.ACTUAL",
    "MS.CASTER1.MOULD.LEVEL.STR05.ACTUAL",
    "MS.CASTER1.MOULD.LEVEL.STR01.SPEED_ACTUAL",
    "MS.CASTER1.MOULD.LEVEL.STR02.SPEED_ACTUAL",
    "MS.CASTER1.MOULD.LEVEL.STR03.SPEED_ACTUAL",
    "MS.CASTER1.MOULD.LEVEL.STR04.SPEED_ACTUAL",
    "MS.CASTER1.MOULD.LEVEL.STR05.SPEED_ACTUAL"
  ]
}
